module.exports = __webpack_public_path__ + "img/budapest.830bdf37.jpg";